import React from "react";

export function FlexibleHoldsSectionSamHack() {
  return (
    <div className="cw-space-y-8" id="holds">
      Add new Holds here
    </div>
  );
}
